import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './components/Main/Main';
import Compress from './components/Compress/Compress';
import FileReady from './components/FileReady/FileReady';
import Footer from './components/Footer/Footer';

import './main.css';

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={
                    <>
                        <Main />
                        <Compress />
                    </>
                } />

                <Route path="/file/:id" element={<FileReady />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    );
}